<template>
      <v-col>
          <v-card flat>
         <v-data-table
            :key="componentKey"
            :headers="computedHeaders"
            :items="tableItems"
            class="elevation-1"
            :loading="presencesLoadStatus===1"
            :server-items-length="1"
            hide-default-footer
            must-sort
            dense
          >
            <template v-slot:top>
              <v-toolbar flat color="white">
                <v-toolbar-title>Dziennik</v-toolbar-title>
                
                <v-divider
                  class="mx-4"
                  inset
                  vertical
                ></v-divider>

                <v-select v-model="selectedYear"  class="choose_year" :items="lookups.years" hide-details ></v-select>
               
                <v-divider
                  class="mx-4"
                  inset
                  vertical
                ></v-divider>

                <v-select :disabled="selectedChild>0" clearable @click:clear="selectedCourse = 0" label="Grupa" v-model="selectedCourse"  class="choose_year" :items="lookups.courses" hide-details ></v-select>

                <v-divider
                  class="mx-4"
                  inset
                  vertical
                ></v-divider>

                <children-live-search :disabled="selectedCourse>0" clearable :selectedChild="selectedChild" @childSelected="selectedChild=$event" />

                <v-divider
                  class="mx-4"
                  inset
                  vertical
                ></v-divider>

                <v-checkbox  v-model="showError" class="mt-6" label="Niepełne dane"></v-checkbox>

                <v-spacer></v-spacer>

               <v-menu
                                      v-model="selectedDayMenu"
                                      :close-on-content-click="false"
                                      :nudge-right="40"
                                      transition="scale-transition"
                                      offset-y
                                      min-width="150px"
                                    >
                                      <template v-slot:activator="{ on }">
                                        <v-text-field
                                          v-model="selectedDay"
                                          label="Data"
                                          prepend-icon="mdi-calendar"
                                          readonly
                                          v-on="on"
                                          class="choose_date mt-6 mr-5"
                                        ></v-text-field>
                                      </template>
                                      <v-date-picker first-day-of-week="1" v-model="selectedDay" @input="selectedDayMenu = false"></v-date-picker>
                </v-menu>


                <v-dialog v-if="user.permissions['journal'] >= 5" v-model="dialog" max-width="700px">
                  <presence-editor @close="close" :item-editing="itemEditing" />
                </v-dialog>
              </v-toolbar>
            </template>

  
            <template  v-slot:item.present="{ item }">
              <v-simple-checkbox v-if="item.presences  && item.presences.present" v-model="item.presences.present" disabled></v-simple-checkbox>
            </template>
            <template  v-slot:item.breakfast="{ item }">
              <v-simple-checkbox v-if="item.presences && item.presences.present" v-model="item.presences.breakfast" disabled></v-simple-checkbox>
            </template>
            <template  v-slot:item.lunch="{ item }">
              <v-simple-checkbox v-if="item.presences && item.presences.present" v-model="item.presences.lunch" disabled></v-simple-checkbox>
            </template>
            <template  v-slot:item.tea="{ item }">
              <v-simple-checkbox v-if="item.presences && item.presences.present" v-model="item.presences.tea" disabled></v-simple-checkbox>
            </template>
            <template  v-slot:item.absent="{ item }">
              <v-simple-checkbox v-if="item.presences  && !item.presences.present" :value="!item.presences.present" disabled></v-simple-checkbox>
            </template>

            <template v-if="tableItems.length>1" slot="body.append">
                <tr class="v-data-table__selected font-weight-medium subheading">
                        <td></td><td></td>
                        <td>Suma</td>
                        <td>{{ sumField('present')}}</td>
                        <td></td>
                        <td>{{ sumField('breakfast')}}</td>
                        <td>{{ sumField('lunch')}}</td>
                        <td>{{ sumField('tea')}}</td>
                        <td></td>
                        <td>{{ sumFieldOpposite('present')}}</td>
                        <td></td>
                        <td></td>
                </tr>
            </template>

            <template  v-slot:item.actions="{ item }">
                <v-tooltip v-if="item.presences && user.permissions['journal'] >= 5 && item.settlements_count===0" right>
                  <template v-slot:activator="{ on }">
                  <v-icon
                    v-on="on"
                    size="18"
                    class="mr-2"
                    @click="editItem(item)"
                  >
                    mdi-pencil
                  </v-icon>
                  </template>
                    <span>Edytuj</span>
                </v-tooltip>
                <v-tooltip v-if="!item.presences && user.permissions['journal'] >= 5 && item.settlements_count===0" right>
                  <template v-slot:activator="{ on }">
                  <v-icon
                    v-on="on"
                    size="18"
                    class="mr-2"
                    @click="editItem(item)"
                  >
                    mdi-plus-thick
                  </v-icon>
                  </template>
                    <span>Dodaj</span>
                </v-tooltip>

                <v-tooltip v-if="item.presences && user.permissions['journal'] >= 5 && item.settlements_count===0" right>
                  <template v-slot:activator="{ on }">
                  <v-icon
                    v-on="on"
                    size="18"
                    class=""
                    color="error"
                    @click="forceDeleteItem(item)"
                  >
                    mdi-delete-forever
                  </v-icon>
                  </template>
                  <span>Usuń na stałe</span>
                </v-tooltip>

                
            </template> 

          </v-data-table> 

          </v-card>
      
      <confirm ref="confirm"></confirm>
      </v-col>
      

</template>


<script>
  import confirm from '../components/Confirm'
  import required from 'vuelidate/lib/validators/required'
  import ChildrenLiveSearch from '../components/ChildrenLiveSearch.vue';
  import PresenceEditor from '../components/PresenceEditor'
  
  export default {
    components:{
      confirm,
      ChildrenLiveSearch,
      PresenceEditor
    },
    data: () => ({
      componentKey:0,
      tableOptions: {},
      dialog: false,
      itemEditing:false,
      itemWasDefault:false,
      selectedDayMenu:false,
      headers: [
        { text: '',align: 'start',sortable: false,value: 'lp',filterable:false},
        { text: 'Nazwisko', value: 'surname',filterable:true,filterColumn:"surname" },
        { text: 'Imię', value: 'name',filterable:true,filterColumn:"name" },
        { text: 'Obecny', value: 'present',filterable:true,filterColumn:"presences.present",sortable: false },
        { text: 'Godzina wejścia', value: 'presences.entry',filterable:true,filterColumn:"presences.entry"  },
        { text: 'Śniadanie', value: 'breakfast',filterable:true,filterColumn:"presences.breakfast",sortable: false  },
        { text: 'Obiad', value: 'lunch',filterable:true,filterColumn:"presences.lunch",sortable: false },
        { text: 'Podwieczorek', value: 'tea',filterable:true,filterColumn:"presences.tea",sortable: false },
        { text: 'Godzina wyjścia', value: 'presences.leave',filterable:true,filterColumn:"presences.leave" },
        { text: 'Nieobecny', value: 'absent',filterable:true,filterColumn:"presences.present",sortable: false },
        { text: 'Uwagi', value: 'presences.note',filterable:false,filterColumn:"presences.note" },
        { text: 'Akcje', value: 'actions', sortable: false,filterable:false },
      ],
    }),
    validations: {
      
    },
    watch: {
      tableOptions: {
        handler () {
          var currentOptions = {...this.options};
          const { sortBy, sortDesc } = this.tableOptions
        
          //zmiana sortowania
          if (sortBy.length === 1 && sortDesc.length === 1) {
            currentOptions.orderBy = _.find(this.headers,{'value':sortBy[0]}).filterColumn;
            currentOptions.orderDirection = sortDesc[0]?'desc':'asc';
            this.options = currentOptions;
          } 
        },
        deep: true,
      },
    
      dialog (val) {
        this.$v.$reset()
        val || this.close()
      },
      presenceEditStatus(val){
        if(val===2){
          this.close();
          this.componentKey += 1;
          if(this.showError){
            this.loadPresences();
          }
        }
      },
      presenceDeleteStatus(val){
        if(val===2){
          this.componentKey += 1;
        }
      }
    },
    computed: {
      user(){
        return this.$store.getters.getUser;
      },
      lookups(){
        return this.$store.getters.getLookups;
      },
      
      options:{
        get () {  
          return this.$store.getters.getPresenceOptions;
        },
        set (value) {
          this.search='';
          this.$store.dispatch( 'setPresenceOptions', {options:value} )
        }
      },
      selectedYear:{
        get () {
          return this.$store.getters.getPresenceOptions.selectedYear;
        },
        set (value) {
          var currentOptions = {...this.options};
          currentOptions.selectedYear = value;
          currentOptions.selectedCourse = 0;
          this.options = currentOptions;
          this.$store.dispatch( 'loadCourseLookup', {year_id:this.options.selectedYear} );
        }
      },

      selectedCourse:{
        get () {
          return this.$store.getters.getPresenceOptions.selectedCourse;
        },
        set (value) {
          var currentOptions = {...this.options};
          currentOptions.selectedCourse = value;
          this.options = currentOptions;
          //this.$store.dispatch( 'loadCourseLookup', {year_id:this.options.selectedCourse} );
        }
      },
      selectedChild:{
        get () {
          return this.$store.getters.getPresenceOptions.selectedChild;
        },
        set (value) {
          var currentOptions = {...this.options};
          currentOptions.selectedChild = value;
          this.options = currentOptions;
        }
      },  
      selectedDay:{
        get () {
          return this.$store.getters.getPresenceOptions.selectedDay;
        },
        set (value) {
          var currentOptions = {...this.options};
          currentOptions.selectedDay = value;
          this.options = currentOptions;
          //this.$store.dispatch( 'loadCourseLookup', {year_id:this.options.selectedCourse} );
        }
      },
      showError: {
        get () {
          return this.$store.getters.getPresenceOptions.showError;
        },
        set (value) {
          var currentOptions = {...this.options};
          currentOptions.showError = value;
          this.options = currentOptions;
        }
      },
      editedItem(){
        return this.$store.getters.getPresenceEdit.presences;
      },
      childItem(){
        return this.$store.getters.getPresenceEdit;
      },
      tableItems(){
        return this.$store.getters.getPresences;
      },
      presencesLoadStatus(){
        return this.$store.getters.getPresencesLoadStatus();
      },
      presenceEditLoadStatus(){
        return this.$store.getters.getPresenceEditLoadStatus;
      },
      presenceEditStatus(){
        return this.$store.getters.getPresenceEditStatus();
      },
      presenceEditText(){
        return this.$store.getters.getPresenceEditText
      },
      presenceAddStatus(){
        return this.$store.getters.getPresenceAddStatus();
      },
      presenceAddText(){
        return this.$store.getters.getPresenceAddText;
      },
      presenceDeleteStatus(){
        return this.$store.getters.getPresenceDeleteStatus();
      },
      computedHeaders () {
        if(this.user.permissions['journal'] < 5) return this.headers.filter(h => h.value!=='actions')
        else return this.headers
      },
    
    },
    mounted(){
      if(this.lookups.years.length>0){
        this.loadPresences();
      }else{
        this.$store.dispatch( 'loadLookups' );
        setTimeout(() => {
          this.loadPresences();
        }, 2000)
      }
    },
    methods: {
      loadPresences(){
        var currentOptions = {...this.$store.getters.getPresenceOptions};
        var date = new Date(); 
        currentOptions.selectedDay = date.toISOString().substr(0,10);
        this.$store.dispatch( 'setPresenceOptions', {options:currentOptions} )
      },
      editItem (item) {
        this.itemEditing = !_.isEmpty(item.presences);
        this.$store.dispatch( 'loadPresenceEdit', {slug:  item.id});  
        this.dialog = true;
      },
      forceDeleteItem (item) {
        this.$refs.confirm.open('Usuń', 'Czy na pewno chcesz usunać wpis dzieninka na stałe?', { color: 'error' }).then((confirm) => {
            if(confirm){
               this.$store.dispatch( 'forceDeletePresence', {slug:  item.presences.id});
            }
        })
      },
      sumField(key) {
        // sum data in give key (property)
        return this.tableItems.reduce((a, b) => a + ((b.presences && b.presences[key])?1:0 || 0), 0)
      },
      sumFieldOpposite(key) {
        // sum data in give key (property)
        return this.tableItems.reduce((a, b) => a + ((b.presences && !b.presences[key])?1:0 || 0), 0)
      },
      close () {
        this.dialog = false
        this.$v.$reset()
        setTimeout(() => {
          this.$store.dispatch( 'loadPresenceEditDefault'); 
          this.$store.dispatch( 'loadPresenceAddDefault');
          this.itemEditing = false
        }, 300)
      },
    },
  }
</script>

<style scoped>
.search{
      max-width: 250px;
}
.choose_year{
      max-width: 150px;
}
.choose_date{
      max-width: 150px;
}
</style>